/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCardApprovals} from '../api'

 export const useQueryGetCardApprovals = createReactQueryHook('getCardApprovals', getCardApprovals)
